module.exports = __webpack_public_path__ + "img/355.a43cc484.png";